import { orchestrator } from 'satcheljs';
import { getSecondarySubscribers } from '../services/getSecondarySubscribers';
import { getSecondarySubscribers as getSecondarySubscribersAction } from '../actions/getSecondarySubscribers';
import setSecondarySubscribers from '../mutators/setSecondarySubscribers';

export default orchestrator(
    getSecondarySubscribersAction,
    async function getSecondarySubscribersAction() {
        let response = await getSecondarySubscribers();
        setSecondarySubscribers(response);
    }
);
